"use client";

import { TrackedGiftCardLink } from "@/components/shared/TrackedLinks";

interface GiftCardButtonProps {
  source?: string;
}

export function GiftCardButton({ source = "gift_card_button" }: GiftCardButtonProps) {
  return (
    <TrackedGiftCardLink
      source={source}
      className="inline-flex items-center justify-center rounded-lg bg-terracotta hover:bg-terracotta-dark text-white font-medium px-8 py-3 text-lg transition-colors"
    >
      Purchase Gift Card
    </TrackedGiftCardLink>
  );
}
